import { FlowButton } from 'components/ui/flow-button';
import React from 'react';
import { AlertTriangle, RefreshCcw } from 'lucide-react';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Unhandled public website error:', error, errorInfo);
    document.body.classList.remove('custom-cursor-enabled');
    document.body.classList.add('custom-cursor-disabled');
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (!this.state.hasError) {
      return this.props.children;
    }

    return (
      <main className="min-h-screen bg-canvas text-ink flex items-center justify-center px-6 py-20" role="alert">
        <div className="w-full max-w-lg border border-gold/25 bg-surface p-8 text-center shadow-2xl shadow-black/20">
          <div className="mx-auto mb-6 flex h-14 w-14 items-center justify-center border border-gold/30 bg-gold/10">
            <AlertTriangle className="h-7 w-7 text-accent-ink" aria-hidden="true" />
          </div>
          <h1 className="font-display text-3xl font-bold tracking-tight text-ink">Something went wrong</h1>
          <p className="mt-4 font-body text-sm leading-relaxed text-copy/55">
            This page could not finish loading. Reload the page and try the action again.
          </p>
          <FlowButton
            type="button"
            onClick={this.handleReload}
            className="mt-8 inline-flex items-center justify-center gap-3  px-8 py-4 font-body text-[11px] font-bold uppercase tracking-[0.2em]  transition-colors  focus:outline-none focus:ring-2 focus:ring-gold focus:ring-offset-2 focus:ring-offset-obsidian"
          >
            Reload Page <RefreshCcw className="h-4 w-4" aria-hidden="true" />
          </FlowButton>
        </div>
      </main>
    );
  }
}
